import { action } from 'typesafe-actions'
import { EnvelopeInfoRequest, UserEnvelopeProcessRequest } from '../../models/RequestModel'
import { AccountDetailedInfo, EnvelopeStatus } from '../../models/ResponseModel'
import { SmartCard } from '../MainPage/types'
import { ActionTypes } from './types'

export const accountInfoRequest = (payload: SmartCard) =>
  action(ActionTypes.ACCOUNT_INFO_REQUEST, payload)

export const accountInfoFulfilled = (response: AccountDetailedInfo) =>
  action(ActionTypes.ACCOUNT_INFO_FULFILLED, response)

export const accountInfoReject = (response: any) =>
  action(ActionTypes.ACCOUNT_INFO_REJECTED, response)

export const userEnvelopeProcessRequest = (payload: UserEnvelopeProcessRequest) =>
  action(ActionTypes.USER_ENVELOPE_PROCESS_REQUEST, payload)

export const userEnvelopeProcessFulfilled = (response: boolean) =>
  action(ActionTypes.USER_ENVELOPE_PROCESS_FULFILLED, response)

export const changeSelectedProduct = () => action(ActionTypes.CHANGE_SELECTED_PRODUCT)

export const userEnvelopeProcessReject = (response: any) =>
  action(ActionTypes.USER_ENVELOPE_PROCESS_REJECTED, response)

export const envelopeInfoRequest = (request: EnvelopeInfoRequest) =>
  action(ActionTypes.ENVELOPE_QUERY_REQUEST, request)

export const envelopeInfoFulfilled = (response: EnvelopeStatus) =>
  action(ActionTypes.ENVELOPE_QUERY_FULFILLED, response)

export const gibApplicationQueryRequest = (payload: any) =>
  action(ActionTypes.GIB_APPLICATION_QUERY_REQUEST, payload)

export const gibApplicationQueryFulfilled = (payload: any) =>
  action(ActionTypes.GIB_APPLICATION_QUERY_FULFILLED, payload)
